export class HttpError extends Error {
    constructor(message: string, public status?: number) {
        super(message);
        this.name = "HttpError";
    }
} // todo: move this out of adyen to common

export class SessionConflictError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = "SessionConflictError";
    }
}

export class SessionClosedError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = "SessionClosedError";
    }
}
